import React from 'react'
import { EButton, EPageTitle, ETable } from '../../libs/ui'
import PageLayout from '../../PageLayout'
import { Select, Skeleton, Text } from '@mantine/core';
import useStudentEnrolment from './hook/useStudentEnrolment';
import { BsDownload, BsUpload } from 'react-icons/bs';
import { ECard } from '../../libs/ui/src/Card/ECard';
import { CSVLink } from 'react-csv';
import moment from 'moment';

const StudentEnrolment = () => {
    const {
      enrolmentSearchValue,
      handleChangeenrolmentSearch,
      loading,
      currentItems,
      setLoading,
      headers,
    } = useStudentEnrolment();
  return (
    <PageLayout>
      <EPageTitle title="Student Enrolment" />
      <div className="filter-container">
        {/* <h4>Filters</h4> */}
        <div className="flex justify-between w-full items-end">
          <div className="flex justify-between gap-3">
            <div className="flex gap-5">
              <Select
                label="Session"
                placeholder="Select"
                className=" w-1/5 grow"
                value={enrolmentSearchValue?.SessionId}
                data={[
                  { label: "2023-2024", value: "2024" },
                  { label: "2024-2025", value: "2025" },
                  { label: "2025-2026", value: "2026" },
                  { label: "2026-2027", value: "2027" },
                ]}
                onChange={(e: any) =>
                  handleChangeenrolmentSearch({ name: "SessionId", value: e })
                }
              />
            </div>
            <div className="flex gap-3 items-end">
              <EButton
                className="btn-blue"
                disabled={
                  enrolmentSearchValue?.SessionId?.length > 0 ? false : true
                }
                onClick={() => {}}
              >
                Search
              </EButton>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <ECard noHeader title="" customClass="overflow-auto">
          {!loading ? (
            <>
              {currentItems?.length > 0 ? (
                <>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <CSVLink
                      data={currentItems}
                      headers={headers}
                      filename={`district_wise_enrolment_${moment().format(
                        "MMM",
                      )}-${moment().format("YYYY")}.csv`}
                    >
                      <EButton
                        className="btn-blue"
                        rightIcon={<BsDownload />}
                        // disabled={!selectedMonth}
                        // // disabled={true}
                        // loading={isSearching}
                        onClick={() => {}}
                      >
                        download Report
                      </EButton>
                    </CSVLink>
                  </div>
                  <ETable>
                    <thead>
                      <tr>
                        <th colSpan={8} style={{ textAlign: "center" }}>
                          District Wise Class Wise Enrollment
                        </th>
                      </tr>
                      <tr>
                        <th>District Name</th>
                        <th>Balwatika</th>
                        <th>First</th>
                        <th>Second</th>
                        <th>Third</th>
                        <th>Fourth</th>
                        <th>Fifth</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item: any) => {
                        return (
                          <tr>
                            <td>{item.District_Name}</td>
                            <td>{item.Balwatika}</td>
                            <td>{item.First}</td>
                            <td>{item.Second}</td>
                            <td>{item.Third}</td>
                            <td>{item.Fourth}</td>
                            <td>{item.Fifth}</td>
                            <td>{item.Total}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </ETable>
                </>
              ) : (
                <div className="text-blue-600 text-sm mt-2 mb-2 text-center">
                  <Text fz="md">No record Found!</Text>
                </div>
              )}
            </>
          ) : (
            <Skeleton height={220} radius="md" />
          )}
        </ECard>
      </div>
    </PageLayout>
  );
}

export default StudentEnrolment